import React, { Component } from "react";
import { Responsive } from "react-admin";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import Tooltip from "@material-ui/core/Tooltip";
import UserIcon from "@material-ui/icons/AccountBox";
import CancelIcon from "@material-ui/icons/Cancel";
import classnames from "classnames";
import myRestClient from "../common/restClient";
import TranslatedText from "./TranslatedText";
import history from "../common/history";

export default class EnableButton extends Component {
    state = { showSnackBar: false, error: false, show_confirm_dialog: false };

    unlock = () => {
        const { action, resource_id, current_entity, redirect } = this.props;
        const body = {
            data: {
                action,
                resource_id
            }
        };
        myRestClient("UNLOCK", current_entity, body).then(
            () => {
                this.setState({
                    showSnackBar: true,
                    show_confirm_dialog: false
                });
                if (current_entity !== "installations") {
                    if (redirect) {
                        history.push(redirect);
                    }
                }
            },
            () => {
                this.setState({ error: true, show_confirm_dialog: false });
            }
        );
    };

    renderSnackBar() {
        return (
            <Snackbar
                open={this.state.showSnackBar}
                autoHideDuration={6000}
                message={this.renderSnackMessage()}
                onClose={_ =>
                    this.setState({
                        error: false,
                        showSnackBar: false,
                        entity: null
                    })
                }
            />
        );
    }

    renderSnackMessage() {
        const { current_entity } = this.props;
        return this.state.error === false ? (
            <span id="snack-message">
                <TranslatedText
                    resource_name={
                        current_entity !== "installations"
                            ? `resources.${current_entity}.actions.enabled`
                            : "resources.installations.actions.enabledDisdetta"
                    }
                />
            </span>
        ) : (
            <span id="snack-message">
                <TranslatedText
                    resource_name={`resources.${current_entity}.actions.errorEnabled`}
                />
            </span>
        );
    }

    renderIcon() {
        const { action } = this.props;
        if (action === "enable_installation") {
            return <CancelIcon />;
        }
        return <UserIcon />;
    }

    handleCancel = () => {
        this.setState({
            show_confirm_dialog: false
        });
    };

    renderDialogConfirm() {
        const { classes = {}, className } = this.props;
        return this.state.show_confirm_dialog ? (
            <Dialog
                disableBackdropClick
                disableEscapeKeyDown
                maxWidth="xs"
                open={this.state.show_confirm_dialog}
            >
                <DialogTitle>
                    <b>
                        <TranslatedText
                            resource_name={`resources.installations.actions.enable`}
                        />
                    </b>
                </DialogTitle>
                <DialogContent>
                    <TranslatedText
                        resource_name={
                            "resources.installations.actions.disdetta_cancel"
                        }
                    />
                </DialogContent>
                <DialogActions>
                    <div>
                        {" "}
                        <Button onClick={this.handleCancel} color="primary">
                            <TranslatedText
                                resource_name={"ra.actions.cancel"}
                            />
                        </Button>
                        <Button
                            onClick={this.unlock}
                            variant="contained"
                            color="secondary"
                            className={classnames(
                                "ra-delete-button",
                                classes.confirmationDeleteButton,
                                className
                            )}
                        >
                            <TranslatedText
                                resource_name={"ra.actions.confirm"}
                            />
                        </Button>
                    </div>
                </DialogActions>
            </Dialog>
        ) : null;
    }

    handleClick = () => {
        this.setState({
            show_confirm_dialog: true
        });
    };

    render() {
        const { current_entity } = this.props;
        return (
            <span>
                <Button
                    color="primary"
                    target="_blank"
                    onClick={
                        current_entity === "installations"
                            ? this.handleClick
                            : this.unlock
                    }
                >
                    <Responsive
                        small={
                            <Tooltip
                                title={
                                    <TranslatedText
                                        resource_name={`resources.${current_entity}.actions.enable`}
                                    />
                                }
                            >
                                {this.renderIcon()}
                            </Tooltip>
                        }
                        medium={this.renderIcon()}
                    />
                    <Responsive
                        small={<span />}
                        medium={
                            <span style={{ paddingLeft: "0.5em" }}>
                                <TranslatedText
                                    resource_name={`resources.${current_entity}.actions.enable`}
                                />
                            </span>
                        }
                    />
                </Button>
                {this.renderSnackBar()}
                {this.renderDialogConfirm()}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/EnableButton.js